export const ISSUES_EXCEPTION_DICTIONARY = {
  issueAlreadyExists: 'issue.already.exists',
};
